"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformationSimulateIn = void 0;
class TransformationSimulateIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return TransformationSimulateIn.attributeTypeMap;
    }
}
exports.TransformationSimulateIn = TransformationSimulateIn;
TransformationSimulateIn.discriminator = undefined;
TransformationSimulateIn.attributeTypeMap = [
    {
        "name": "channels",
        "baseName": "channels",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "code",
        "baseName": "code",
        "type": "string",
        "format": ""
    },
    {
        "name": "eventType",
        "baseName": "eventType",
        "type": "string",
        "format": ""
    },
    {
        "name": "payload",
        "baseName": "payload",
        "type": "any",
        "format": ""
    }
];
//# sourceMappingURL=TransformationSimulateIn.js.map